import { render } from "./service-auth.vue?vue&type=template&id=e1fd26c4&scoped=true&ts=true"
import script from "./service-auth.vue?vue&type=script&lang=ts"
export * from "./service-auth.vue?vue&type=script&lang=ts"

import "./service-auth.vue?vue&type=style&index=0&id=e1fd26c4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fd26c4"]])

export default __exports__